// Browser-only by nature: a plain GET file download fires no completion event, so the
// page watches for the cookie the server sets alongside the file (keyed by a one-off
// token) to stop its spinner. A failed export redirects back, which reloads the page.
const cookieValue = (name) =>
  document.cookie
    .split('; ')
    .find((part) => part.startsWith(`${name}=`))
    ?.slice(name.length + 1) ?? null

// Resolves once the cookie holds `token` (then clears it), or after `timeoutMs`.
export function waitForDownloadCookie(name, token, { intervalMs = 250, timeoutMs = 120000 } = {}) {
  return new Promise((resolve) => {
    const startedAt = Date.now()
    const timer = setInterval(() => {
      const arrived = cookieValue(name) === token
      if (!arrived && Date.now() - startedAt < timeoutMs) return
      clearInterval(timer)
      if (arrived) document.cookie = `${name}=; max-age=0; path=/`
      resolve(arrived)
    }, intervalMs)
  })
}
